import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Blank from "../components/DefaultStyles/Blank";
import LineBtn, { LineBtnIcon } from "../components/Button/LineBtn";
import useMy from "../hooks/useMy";
import { useApi } from "../hooks/useApi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Flex from "../components/DefaultStyles/Flex";
import MyInfoTable from "../components/pages/My/MyInfoTable";
import PwResettingModal from "../components/pages/Login/PwResettingModal";
import OldPwInputModal from "../components/pages/My/OldPwInputModal";
import { useSetRecoilState } from "recoil";
import { userDataType } from "./Login";
import Loader from "../components/DefaultStyles/Loader";

export default function My() {
  const navigate = useNavigate();
  const { name } = useMy();

  const [isLoading, setIsLoading] = useState(false);
  const [logoutBtnClick, setLogoutBtnClick] = useState(false);
  const [oldPwInputModal, setOldPwInputModal] = useState(false);
  const [pwResettingModal, setPwResettingModal] = useState(false);
  const [pwResettingSuccessToast, setPwResetgingSuccessToast] = useState(false);
  const [oldPw, setOldPw] = useState("");

  const setUserData = useSetRecoilState(userDataType);

  const { response, error } = useApi({
    method: "post",
    url: logoutBtnClick ? `logout` : undefined,
  });

  useEffect(() => {
    if (logoutBtnClick) {
      setIsLoading(true);
    }

    if (response?.status === 200) {
      setIsLoading(false);

      sessionStorage.clear();
      localStorage.clear();

      setUserData({
        name: "",
        email: "",
        grade: "",
        sid: "",
      });

      navigate("/");
    } else if ((response?.status ?? 0) > 400) {
      setIsLoading(false);
    }
  }, [name, navigate, response, setUserData, logoutBtnClick]);

  useEffect(() => {
    if (error) {
      toast.error("로그아웃에 실패했습니다.");
    }
  }, [error]);

  useEffect(() => {
    if (pwResettingSuccessToast) {
      toast.success("비밀번호 설정이 완료되었습니다.");
    }
  }, [pwResettingSuccessToast]);

  return (
    <MyContainer>
      <MyInfoBox>
        <MyInfoBoxTitle>관리자 정보</MyInfoBoxTitle>

        <MyInfoTableBorder />

        <MyInfoTable />

        <MyInfoTableBorder />

        <Blank blankHeight={20} />

        <Flex gapSize={10}>
          <LineBtn
            btnText="로그아웃"
            icon="logout"
            btnClickEvent={() => setLogoutBtnClick(true)}
          />

          <LineBtn
            btnText="비밀번호 재설정"
            icon="key"
            btnClickEvent={() => setOldPwInputModal(true)}
            customIcon={
              <CustomLineBtnIcon className="material-symbols-outlined">
                key
              </CustomLineBtnIcon>
            }
          />
        </Flex>

        {/* 기존 비밀번호 입력 모달 */}
        {oldPwInputModal && (
          <OldPwInputModal
            closeEvent={() => setOldPwInputModal(false)}
            confirmEvent={() => setPwResettingModal(true)}
            oldPw={oldPw}
            setOldPw={setOldPw}
          />
        )}

        {/* 새로운 비밀번호 설정 모달 */}
        {pwResettingModal && (
          <PwResettingModal
            closeEvent={() => setPwResettingModal(false)}
            confirmEvent={() => {
              setPwResettingModal(false);
              setPwResetgingSuccessToast(true);
            }}
            originPw={oldPw}
          />
        )}

        {isLoading && <Loader />}
      </MyInfoBox>
    </MyContainer>
  );
}

const MyContainer = styled.div`
  margin-top: 140px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MyInfoBox = styled.div`
  width: 480px;
  height: 342px;
  border-radius: 10px;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MyInfoBoxTitle = styled.h1`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #2f2f38;
  margin-bottom: 24px;
`;

const MyInfoTableBorder = styled.div`
  width: 100%;
  height: 2px;
  background-color: #d4d9e1;
`;

const CustomLineBtnIcon = styled(LineBtnIcon)`
  transform: rotate(-45deg);
  margin-right: 4px;
`;
